const passwordRevealer = function() {

    const defaults = {
        selectors: {
            container: ".js-passwordRevealer",
            input: "input[type=\"password\"]",
        },
        classes: {
            trigger: "js-passwordRevealer-trigger",
        },
    };

    function init() {

        $(defaults.selectors.container).each(function(){

            var container = $(this),
                target = $(defaults.selectors.input, container);

            if (target.length === 0){
                return;
            }

            container.addClass("is-active");

            var trigger = $("<span/>").addClass(defaults.classes.trigger).appendTo(container);

            trigger.click(function(e){

                if (target.attr("type") === "password"){

                    if (target.val() !== ""){
                        target.attr("type", "text");
                        container.addClass("is-revealed");
                    }

                } else {
                    target.attr("type", "password");
                    container.removeClass("is-revealed");
                }

            });


        });

    }

    return {
        init: init
    }
}();

passwordRevealer.init();
